// extracted by mini-css-extract-plugin
export var logo = "_hd-2";
export var logoWrapper = "_hd-1";
export var strip = "_hd-0";